var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1538 4.53846C19.4283 4.53846 20.4615 5.57165 20.4615 6.84615V17.1026C20.4615 18.3771 19.4283 19.4103 18.1538 19.4103H14.0513C12.7768 19.4103 11.7436 18.3771 11.7436 17.1026V16.0769C11.7436 15.6521 11.3992 15.3077 10.9744 15.3077C10.5495 15.3077 10.2051 15.6521 10.2051 16.0769V17.1026C10.2051 19.2267 11.9271 20.9487 14.0513 20.9487H18.1538C20.278 20.9487 22 19.2267 22 17.1026V6.84615C22 4.72198 20.278 3 18.1538 3H14.0513C11.9271 3 10.2051 4.72198 10.2051 6.84615V7.87179C10.2051 8.29663 10.5495 8.64102 10.9744 8.64102C11.3992 8.64102 11.7436 8.29663 11.7436 7.87179V6.84615C11.7436 5.57165 12.7768 4.53846 14.0513 4.53846H18.1538ZM7.41572 7.32787C7.11532 7.02746 6.62827 7.02746 6.32787 7.32787L2.2253 11.4304C1.9249 11.7308 1.9249 12.2179 2.2253 12.5183L6.32787 16.6208C6.62827 16.9213 7.11532 16.9213 7.41572 16.6208C7.71612 16.3204 7.71612 15.8334 7.41572 15.533L4.62632 12.7436L17.1282 12.7436C17.553 12.7436 17.8974 12.3992 17.8974 11.9744C17.8974 11.5495 17.553 11.2051 17.1282 11.2051L4.62632 11.2051L7.41572 8.41572C7.71612 8.11532 7.71612 7.62827 7.41572 7.32787Z",
    fill: "#EC094D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2647b8a4c4c251ef1f50171509b0fa25.svg";
export { ForwardRef as ReactComponent };